import * as React from 'react';
import * as Redux from 'redux';
import { ResultsProps } from '../../state-helpers/site-settings-props';
import { getResultsText } from '../../actions/results-count';

interface IResultsCountMessageProps {
  totalResults: number;
  pageResults: number;
  pageSize: number;
  currentPage: number;
  isLoading: boolean;
    customClasses?: string;
    generativeText: string;
    generativeResultHeader: string;
    disableGenerativeResult: boolean;

}

export class ResultsCountMessage extends React.Component<IResultsCountMessageProps, any> {
  render() {

    return (
      <div className="loading-status">
            {
                this.props.isLoading ?
                    <div className="loader-block search-results-loader">Loading...</div> :
                    <div>
                        {!this.props.disableGenerativeResult ?
                            <div className="generative-ai-container">
                                <p className='generative-ai-header' dangerouslySetInnerHTML={{ __html: this.props.generativeResultHeader }}></p>
                                <p className='generative-ai-text' dangerouslySetInnerHTML={{ __html: this.props.generativeText }}></p>
                            </div>
                            : null
                        }
                        <p className="loading-status-message">{getResultsText(this.props.totalResults,
                            this.props.pageResults,
                            this.props.pageSize,
                            this.props.currentPage)}
                        </p>
                    </div>
              
            }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/global/components/results/results-count-msg.tsx